.gen-form {
    margin: 20px;
    padding: 20px;
    border: 1px solid #ccc;
    width: fit-content;
}

.action-box{
    width: fit-content;
    display: inline-block;
}